import makeStyles from '@material-ui/core/styles/makeStyles';
export var useStyles = makeStyles({
    wrapper: {
        justifyContent: 'space-between',
        background: '#151515',
        borderBottom: '1px solid #8e8e8e40',
    },
}, { name: 'RowWrapper' });
